import _ from 'lodash'

export default ->
	__resolveType: ->
		'Account'
